<template>
  <div class="yzm-textdiv flex-1" :style="{ ...marginStyle }">
    <div v-if="item.setting?.layoutType == 0">
      <div class="text" style="margin-bottom: 8px" :style="{ ...textStyle }">{{ item.setting?.title }}</div>
      <div class="btn line-1" :style="{ ...btnStyle }">{{ item.setting?.btnText }}</div>
    </div>
    <div v-if="item.setting?.layoutType == 1">
      <div class="btn line-1" :style="{ ...btnStyle }">{{ item.setting?.btnText }}</div>
      <div class="text" style="margin-yop: 8px" :style="{ ...textStyle }">{{ item.setting?.title }}</div>
    </div>
    <div class="flex flex-center flex-item-center" v-if="item.setting?.layoutType == 2">
      <div class="text flex-1" style="margin-right: 8px" :style="{ ...textStyle }">{{ item.setting?.title }}</div>
      <div class="btn line-1" :style="{ ...btnStyle }">{{ item.setting?.btnText }}</div>
    </div>
    <div class="flex flex-center flex-item-center" v-if="item.setting?.layoutType == 3">
      <div class="btn line-1" :style="{ ...btnStyle }">{{ item.setting?.btnText }}</div>
      <div class="text flex-1" style="margin-left: 8px" :style="{ ...textStyle }">{{ item.setting?.title }}</div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed, ref, onMounted, defineEmits } from 'vue'
import { defaultProps } from './defaultProps'
const props = defineProps({
  ...defaultProps
})
const marginStyle = computed(() => {
  let item = props.item.setting
  return {
    marginTop: `${item.marginTop}px`,
    marginBottom: `${item.marginBottom}px`,
    marginLeft: `${item.marginLeft}px`,
    marginRight: `${item.marginRight}px`
  }
})
const btnStyle = computed(() => {
  let item = props.item.setting
  let type = item.btnStyleObj?.btnStyleType
  return {
    fontSize: `${item.btnFontStyle.fontSize || 14}px`,
    fontWeight: item.btnFontStyle.fontWeight,
    fontStyle: item.btnFontStyle.fontStyle,
    color: item.btnColor,
    background: [1, 3].includes(type) ? item.btnBackground : '#ffffff',
    border: [2, 4].includes(type) ? `1px solid ${item.btnBackground}` : '',
    borderRadius: [1, 2].includes(type) ? '4px' : '100px'
  }
})
const textStyle = computed(() => {
  let item = props.item.setting
  return {
    color: item.textColor,
    fontSize: `${item.textFontStyle.fontSize}px`,
    fontWeight: item.textFontStyle.fontWeight,
    fontStyle: item.textFontStyle.fontStyle
  }
})
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-textdiv {
  .text {
    font-size: 12px;
    color: #888888;
  }
  .btn {
    height: 32px;
    text-align: center;
    padding: 6px 10px;
    width: 72px;
    box-sizing: border-box;
  }
}
</style>
